import { useRPCContext } from "../../../../contexts/RPCContext.js";
import { useRegionScope } from "../../../../contexts/RegionScopeContext.js";
import { useSessionStorage } from "../../../../hooks/useSessionStorage.js";
import { useEffect, useState } from "react";
import { Icon, MultiSelect, Tabs } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { useUpdateEffect } from "ahooks";
//#region src/modules/Locations/shared/LocationLogEntries/SearchFilterLocationLogEntryTypeActiveInactiveMultiSelect.tsx
var LIMIT = 25;
function SearchFilterLocationLogEntryTypeActiveInactiveMultiSelect({ focused, onChange, onClearSelection, onClick, value }) {
	const [logEntryTypeTab, setLogEntryTypeTab] = useState("active");
	const [activeLogEntryTypes, setActiveLogEntryTypes] = useSessionStorage("activeEntryTypeLogFilter");
	const [inactiveLogEntryTypes, setInactiveLogEntryTypes] = useSessionStorage("inactiveEntryTypeLogFilter");
	const [totalOptions, setTotalOptions] = useState(0);
	const [options, setOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const { rpcService } = useRPCContext();
	const regionScope = useRegionScope();
	useEffect(() => {
		if (!value?.length) {
			setActiveLogEntryTypes(void 0);
			setInactiveLogEntryTypes(void 0);
		}
	}, [value]);
	useEffect(() => {
		setLoading(true);
		rpcService.Locations.GetLocationLogEntryTypesList.v1.call({
			active: logEntryTypeTab === "active",
			pagination: { limit: LIMIT },
			regionIds: regionScope
		}).then(({ data }) => {
			setTotalOptions(data.total);
			setOptions(data.entryTypes);
		}).finally(() => setLoading(false));
	}, [logEntryTypeTab, regionScope]);
	const handleLoadOptions = (opts) => {
		if (opts?.additional && options.length < totalOptions) rpcService.Locations.GetLocationLogEntryTypesList.v1.call({
			active: logEntryTypeTab === "active",
			pagination: {
				limit: LIMIT,
				skip: options.length
			},
			regionIds: regionScope,
			searchText: opts.text
		}).then(({ data }) => {
			setOptions((prevOptions) => [...prevOptions, ...data.entryTypes]);
		});
		else if (opts.text) rpcService.Locations.GetLocationLogEntryTypesList.v1.call({
			active: logEntryTypeTab === "active",
			pagination: { limit: LIMIT },
			regionIds: regionScope,
			searchText: opts.text
		}).then(({ data }) => {
			setOptions(data.entryTypes);
		});
	};
	useUpdateEffect(() => {
		onChange([...activeLogEntryTypes || [], ...inactiveLogEntryTypes || []]);
	}, [activeLogEntryTypes, inactiveLogEntryTypes]);
	return /* @__PURE__ */ jsx("div", {
		className: "bg-surface-strong p-xs w-full",
		children: /* @__PURE__ */ jsxs("div", {
			onClick,
			className: "space-y-sm w-full font-bold",
			children: [/* @__PURE__ */ jsxs("span", {
				className: "flex w-full justify-between hover:cursor-pointer",
				children: [/* @__PURE__ */ jsx("span", { children: "Entry Types" }), /* @__PURE__ */ jsx("span", { children: focused ? /* @__PURE__ */ jsx(Icon, { Icon: MdExpandLess }) : /* @__PURE__ */ jsx(Icon, { Icon: MdExpandMore }) })]
			}), focused && /* @__PURE__ */ jsx("div", {
				onClick: (e) => e.stopPropagation(),
				children: /* @__PURE__ */ jsxs(Tabs, {
					currentKey: logEntryTypeTab,
					onTabClick: setLogEntryTypeTab,
					children: [/* @__PURE__ */ jsx(Tabs.Tab, {
						title: "Active",
						tabKey: "active",
						children: /* @__PURE__ */ jsx(MultiSelect, {
							disabled: loading,
							disableSelectAll: true,
							loading,
							loadOptions: handleLoadOptions,
							onChangeValue: (val) => {
								setActiveLogEntryTypes(val);
							},
							onClearSelection,
							optionLabelExtractor: (option) => option.name,
							options,
							optionValueExtractor: (option) => option.id,
							placeholder: "Active Entry Types",
							totalOptions,
							value: activeLogEntryTypes || []
						})
					}), /* @__PURE__ */ jsx(Tabs.Tab, {
						title: "Inactive",
						tabKey: "inactive",
						children: /* @__PURE__ */ jsx(MultiSelect, {
							disabled: loading,
							disableSelectAll: true,
							loading,
							loadOptions: handleLoadOptions,
							onChangeValue: (val) => {
								setInactiveLogEntryTypes(val);
							},
							onClearSelection,
							optionLabelExtractor: (option) => option.name,
							options,
							optionValueExtractor: (option) => option.id,
							placeholder: "Inactive Entry Types",
							totalOptions,
							value: inactiveLogEntryTypes || []
						})
					})]
				})
			})]
		})
	});
}
//#endregion
export { SearchFilterLocationLogEntryTypeActiveInactiveMultiSelect };

//# sourceMappingURL=SearchFilterLocationLogEntryTypeActiveInactiveMultiSelect.js.map